(function(){
  const rootNodes = document.querySelectorAll('[data-bb-universe]');
  if(!rootNodes.length) return;

  rootNodes.forEach((root, rootIndex)=>{
    root.querySelectorAll('.bb-btn,.bb-glass,.bb-shop-card,.bb-orbit-card,.bb-rec-card,.bb-category-pill,.bb-tab-button,.bb-mini-card,.bb-media-slot,.bb-proof-card,.bb-support-grid article,.bb-story-pulses span').forEach((el, index)=>{
      const phase = ((index * 4.73) + (rootIndex * 2.41)) % 24;
      el.style.setProperty('--delay', `-${phase.toFixed(2)}s`);
      el.style.setProperty('--sweep', `${(15 + (index % 7) * 2.15).toFixed(1)}s`);
      el.style.setProperty('--card-cycle', `${(12 + (index % 6) * 1.65).toFixed(1)}s`);
      el.style.setProperty('--title-cycle', `${(8.5 + (index % 5) * 1.25).toFixed(1)}s`);
      el.style.setProperty('--tile-x', `${18 + ((index * 23) % 58)}%`);
      el.style.setProperty('--tile-y', `${16 + ((index * 31) % 62)}%`);
    });

    const setCardState = (card, open) => {
      card.classList.toggle('is-flipped', open);
      card.setAttribute('aria-pressed', open ? 'true' : 'false');
      card.setAttribute('aria-expanded', open ? 'true' : 'false');
    };

    const bindFlip = (selector, options = {}) => {
      root.querySelectorAll(selector).forEach(card=>{
        if(options.skipSoldout && card.classList.contains('is-soldout')) return;
        const flip = event => {
          if(event.target.closest('a,button')) return;
          const open = !card.classList.contains('is-flipped');
          if(open && card.matches('[data-bb-product-flip]')){
            card.closest('.bb-shop-grid')?.querySelectorAll('[data-bb-product-flip].is-flipped').forEach(other=>{
              if(other !== card) setCardState(other, false);
            });
          }
          setCardState(card, open);
          if(open && card.matches('[data-bb-product-flip]')){
            requestAnimationFrame(()=>{
              card.scrollIntoView({block:'nearest', inline:'center', behavior:'smooth'});
            });
          }
        };
        card.addEventListener('click', flip);
        card.addEventListener('keydown', event=>{
          if(event.key === 'Enter' || event.key === ' '){
            event.preventDefault();
            flip(event);
          }
        });
      });
    };

    bindFlip('[data-bb-flip]', {skipSoldout:false});
    bindFlip('[data-bb-product-flip]');

    /* Ray, 2026-09-14: "Add to cart" was posting the form the old-fashioned way,
       so the browser left the product page and landed on /cart. Add over Ajax
       instead and raise the drawer, so the bag opens as a popup and every
       line-item property (the two chosen towel designs on the bundle) rides
       along untouched. If the Ajax add ever fails we let the native submit run
       so nothing is lost. */
    root.querySelectorAll('form.bb-product-form').forEach(form=>{
      form.addEventListener('submit', event=>{
        const btn = form.querySelector('[type="submit"]');
        if(btn && btn.disabled) return;      /* gated (e.g. towels not picked) */
        event.preventDefault();
        if(btn) btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        })
          .then(response=>{
            if(!response.ok) throw new Error('add-failed');
            document.dispatchEvent(new CustomEvent('bb:cart:open'));
            if(btn) btn.disabled = false;
          })
          .catch(()=>{
            if(btn) btn.disabled = false;
            form.submit();                    /* fallback: normal add + /cart */
          });
      });
    });

    /* Ray, 2026-09-14: native variant picker. Selecting a variant radio already
       sets name="id" for the add, so add-to-cart is correct without JS. This
       only mirrors the chosen variant's price up into the hero price line so the
       number the buyer sees matches the tier they picked (e.g. the 2-towel deal). */
    const priceEl = root.querySelector('.bb-price');
    const vopts = root.querySelectorAll('input[name="id"][data-bb-vopt]');
    if(priceEl && vopts.length){
      const syncPrice = () => {
        const on = root.querySelector('input[name="id"][data-bb-vopt]:checked');
        if(on && on.dataset.price){ priceEl.textContent = on.dataset.price; }
      };
      vopts.forEach(opt=>opt.addEventListener('change', syncPrice));
      syncPrice();
    }

    // Keep the selected towel design and the large product preview together.
    if(root.classList.contains('is-towel-product') && vopts.length){
      const preview = root.querySelector('.bb-media-vessel img:not(.bb-product-logo)');
      if(preview){
        const fallback = {src: preview.getAttribute('src'), alt: preview.alt};
        const syncPreview = () => {
          const selected = root.querySelector('[data-bb-vopt]:checked');
          const src = selected && selected.dataset.bbPreviewSrc;
          preview.removeAttribute('srcset');
          preview.src = src || fallback.src;
          preview.alt = src ? selected.dataset.bbPreviewAlt : fallback.alt;
        };
        vopts.forEach(option => option.addEventListener('change', syncPreview));
        syncPreview();
      }
    }

    /* Ray, 2026-09-14: native custom-image upload. Product B ships the field
       visible (rendered without [hidden] server-side) so it stays put. Product
       A renders it hidden and it is revealed only while the "Custom Image"
       design radio (marked data-bb-is-custom="1") is the checked one. The chosen
       file rides the existing FormData add above, so it reaches /cart/add as the
       "Custom image" line-item property with no app. */
    const uploadBox = root.querySelector('[data-bb-upload]');
    if(uploadBox){
      const startsHidden = uploadBox.hasAttribute('hidden');
      const designRadios = root.querySelectorAll('input[name="id"][data-bb-vopt]');
      if(startsHidden && designRadios.length){
        const syncUpload = () => {
          const on = root.querySelector('input[name="id"][data-bb-vopt]:checked');
          uploadBox.hidden = !(on && on.dataset.bbIsCustom === '1');
        };
        designRadios.forEach(r=>r.addEventListener('change', syncUpload));
        syncUpload();
      }
      const fileInput = uploadBox.querySelector('[data-bb-custom-upload]');
      const nameEl = uploadBox.querySelector('[data-bb-upload-name]');
      const previewEl = uploadBox.querySelector('[data-bb-upload-preview]');
      if(fileInput){
        fileInput.addEventListener('change', ()=>{
          const file = fileInput.files && fileInput.files[0];
          if(nameEl){
            nameEl.textContent = file ? file.name : '';
            nameEl.hidden = !file;
          }
          if(previewEl){
            if(file && file.type && file.type.indexOf('image/') === 0){
              const reader = new FileReader();
              reader.onload = e => { previewEl.src = e.target.result; previewEl.hidden = false; };
              reader.readAsDataURL(file);
            } else {
              previewEl.hidden = true;
              previewEl.removeAttribute('src');
            }
          }
        });
      }
    }

    root.querySelectorAll('[data-bb-tabs]').forEach(tabs=>{
      const buttons = Array.from(tabs.querySelectorAll('[data-bb-tab]'));
      const panels = Array.from(tabs.querySelectorAll('[data-bb-panel]'));

      const activate = name => {
        buttons.forEach(button=>{
          const active = button.dataset.bbTab === name;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-selected', active ? 'true' : 'false');
          button.tabIndex = active ? 0 : -1;
        });

        panels.forEach(panel=>{
          const active = panel.dataset.bbPanel === name;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
      };

      buttons.forEach((button, index)=>{
        button.addEventListener('click', ()=>activate(button.dataset.bbTab));
        button.addEventListener('keydown', event=>{
          if(event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          event.preventDefault();
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          const next = buttons[(index + direction + buttons.length) % buttons.length];
          next.focus();
          activate(next.dataset.bbTab);
        });
      });

      const activeButton = buttons.find(button=>button.classList.contains('is-active')) || buttons[0];
      if(activeButton) activate(activeButton.dataset.bbTab);
    });

    let raf = null;
    root.addEventListener('pointermove', event=>{
      if(raf) return;
      raf = requestAnimationFrame(()=>{
        raf = null;
        const rect = root.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width - .5) * 28;
        const y = ((event.clientY - rect.top) / rect.height - .5) * 20;
        root.style.setProperty('--mx', `${x.toFixed(1)}px`);
        root.style.setProperty('--my', `${y.toFixed(1)}px`);
      });
    }, {passive:true});
  });
})();
